import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e0dc3d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invite-profile shadow-sm" }
const _hoisted_2 = ["gender"]
const _hoisted_3 = { class: "profile-image" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "profile-card-body" }
const _hoisted_6 = { class: "profile-card-title" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile-card-subtitle" }, "Managed profile", -1))

import { computed } from 'vue'
import { useFamilyGroupInviteStore } from '@/gp/FamilyGroupInviteStore'
import { LoadMode } from '@/util/AsyncData'
import { Gender } from '@/rd/ResearchDataModel';


export default /*#__PURE__*/_defineComponent({
  __name: 'FamilyGroupInviteProfile',
  props: {
  inviteId: String
},
  setup(__props) {

const props = __props;



const inviteStore = useFamilyGroupInviteStore()

const genderImages: any = {}
genderImages[Gender.Male] = new URL("@/assets/icons/male_gray_150.png", import.meta.url).href
genderImages[Gender.Female] = new URL("@/assets/icons/female_gray_150.png", import.meta.url).href
genderImages["default"] = new URL("@/assets/icons/person_gray_150.png", import.meta.url).href

const inviteRef = computed(() => inviteStore.getAsyncInvite(props.inviteId, LoadMode.EnsureLoaded)?.data)
const profileImageRef = computed(() => genderImages[inviteRef.value?.profileGender ?? "default"])


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "gender-bar",
      gender: inviteRef.value?.profileGender
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", { src: profileImageRef.value }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString(inviteRef.value?.profileDisplayName), 1),
      _hoisted_7
    ])
  ]))
}
}

})